import { devtools, persist } from 'zustand/middleware';
import { createWithEqualityFn as create } from 'zustand/traditional';
import { createSafeJSONStorage } from '../../helpers/storage/persist-storage';
import { isLoggingEnabled, logger } from '../logger/logger';
import { Tab } from './data-management-store.type';
import type { State } from './data-management-store.type';

interface DataManagementStore extends State {
  setActiveTab: (tab: Tab) => void;
}

const useDataManagementStore = create<DataManagementStore>()(
  devtools(
    persist(
      logger((set) => ({
        activeTab: Tab.DataSources,
        setActiveTab: (activeTab: Tab) => set({ activeTab }, false, '[Data Management Store] setActiveTab'),
      })),
      {
        name: 'data-management-storage',
        storage: createSafeJSONStorage(() => localStorage),
      },
    ),
    {
      name: 'Bloomfilter - Data Management Store',
      enabled: isLoggingEnabled,
    },
  ),
);

export { useDataManagementStore };
